import type { AxiosResponse } from "axios";
import camelcaseKeys from "camelcase-keys";
import { axiosAccountInstance } from "@/utils/axios";
import type { Notifications } from "@/types/notification";

type Props = {
  offset: number;
  count: number;
};

export const getNotifications = async (props: Props) => {
  const response: AxiosResponse<Notifications> = await axiosAccountInstance.get("/api/notifications", {
    params: props,
  });

  return {
    notifications: camelcaseKeys(response.data, { deep: true }),
  };
};
